var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-3 pb-3"},[_c('vue-element-loading',{attrs:{"active":_vm.show,"spinner":"ring","color":"#006db3","size":"128","text":"กรุณารอสักครู่...","is-full-screen":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }